module.exports = __webpack_public_path__ + "static/img/促销优惠icon@3x.a0b3b43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/促销优惠icon@3x.png
// module id = 5QH1
// module chunks = 192